/**
 * Auth bridge for virtual-web login.
 *
 * - Embedded in platform-web: calls onAuthRequired prop (triggers platform-web's AuthModalHost).
 * - Standalone: opens the local LoginModal via a callback registered by the LoginModalHost.
 *
 * Components set the handler via registerOpenLogin(); callers invoke openLoginModal().
 */

let _openLoginHandler: (() => void) | null = null;

export function registerOpenLogin(handler: (() => void) | null): void {
  _openLoginHandler = handler;
}

export function openLoginModal(): void {
  if (_openLoginHandler) {
    _openLoginHandler();
  }
}

export function openPlatformAuthModal(mode: 'login' | 'signup') {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent('c7:auth:open', { detail: { mode } }));
}

export function openSignupModal() {
  openPlatformAuthModal('signup');
}
